<template>
  <div class="car-class-box">
        <div class="page">
          <h3>车型展示</h3>
        </div>
         <ul class="case-item">
          <li
            v-for="(item,index) in newsList"
            :key="index"
            v-lazy:background-image="item.Img"
          >
              <div class="case-item-hover">
                <p class="hover-title">{{item.Title}}</p>
                <div class="bottom">{{item.Content}}</div>
              </div>
          </li>
        </ul>
</div>
</template>
<style lang="scss" scoped>
.car-class-box {
    width: 100%;
    margin: 0 auto;
}
 .page {
    text-align: center;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    h3,
    p {
      font-size: 40px;
      font-weight: 400;
      color: #333;
    }
  }
  //经典案例
.case-item {
  max-width: 80%;
  height: 580px;

  gap: 10px;
  padding: 10px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
    display: grid;
  grid-template-columns: repeat(3, 1fr);
  li {
    list-style: none;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-size: contain;
    background-position: center;
    background-origin: content-box;
    margin: 5px;
    padding: 15px;
    background-color: #fff;
    position: relative;
    overflow: hidden;

    // &:hover {
    //   .case-item-hover {
    //     opacity: 1;
    //     transition: all 0.4s ease-in-out;
    //   }
    // }
  }
}
//经典案例hover
.case-item-hover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0;
  .hover-title {
    height: 30px;
    color: #fff;
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    padding: 10px;
    color: #000;
  }
  .bottom {
    width: 100%;
    padding: 0 10px;
    font-size: 16px;
    line-height: 20px;
    margin: 0 auto;
  }
  .more {
    width: 90px;
    padding: 5px 5px;
    margin: 0 auto;
    margin-top: 100px;
    border: 2px solid #fff;
    span {
      color: #fff;
      font-size: 20px;
    }
  }
}
// .swiper-slide:nth-child(2n) {
//   background: skyblue;
// }
// .swiper-slide:nth-child(2n-1) {
//   background: seashell;
// }
.slide-one {
  background: url(../assets/img/home_top.jpg) no-repeat center;
  background-size: cover;
}
.slide-two {
  background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
}
.slide-three {
  background: url(../assets/img/home_anli.jpg) no-repeat center;
  background-size: cover;
}
.order {
  order: -1;
}
.order-img {
  order: 1;
}
</style>
<script> // 替换为你的图片路径
import img1 from '@/assets/img/car1.png'
import img2 from '@/assets/img/car3.png'
import img3 from '@/assets/img/car6.png'
import img4 from '@/assets/img/car4.png'
import img5 from '@/assets/img/car2.png'
import img6 from '@/assets/img/car5.png'
export default {
  name: "CarClass",
  props: {
  
  },
   data() {
    return {
      newsList: [
        {
          Img:img1,
          Title:'标准冷藏箱车',
          Content:'13.4m*2.45m*2.56m 载重22吨，82CMB'
        },
        {
          Img:img2,
          Title:'侧帘半挂车',
          Content:'13.6m*2.45m*2.95m 限重22吨，98CBM'
        },
        {
          Img:img3,
          Title:'二节挂车',
          Content:'15.48m*2.48m*3m 限重28吨，115CBM'
        },
        {
          Img:img4,
          Title:'篷布车',
          Content:'13.6m*2.45m*2.6m 限重22吨，86CBM'
        },
        {
          Img:img5,
          Title:'集装厢车',
          Content:'13.5m*2.45m*2.7m 载重24吨，92CBM'
        },
        {
          Img:img6,
          Title:'特殊平板挂车',
          Content:'16.5m*3m 限重45吨'
        },

      ]
    }
  },
  methods: {
    
  }
};
</script>